module.exports = __webpack_public_path__ + "img/img34.c4645eb7.jpg";